
import React from 'react'
import icon from './svgs/teacherBlue.svg'
import { BaseIcon } from './_base'

export const TeacherBlueIcon = ({ size, fontSize ,sx}) => {
    return (
        <BaseIcon icon={icon} {...{fontSize,size,...sx}} />
    )
}
